import { Box, styled, Typography } from "@mui/material";

export const BlurredGraphContainer = styled(Box)({
  position: "relative",
  width: "100%",
  height: 300,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
});

export const BlurredGraphOverlay = styled(Box)({
  position: "absolute",
  width: "100%",
  height: "100%",
  opacity: 0.3,
  filter: "blur(5px)",
});

export const PerformanceMessage = styled(Typography)(({ theme }) => ({
  textAlign: "center",
  zIndex: 2,
  padding: theme.spacing(2),
  borderRadius: theme.spacing(1),
}));
